var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const CardContentStyle = styled.div `
  line-height: ${props => props.theme.fonts.lineHeight};
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
  font-size: ${props => props.theme.fonts.subArticle};
  text-align: ${(props) => props.align};
  color: ${(props) => (props.dark ? props.theme.colors.darkColor : props.theme.colors.mainColor)};
  ${(props) => props.imgResponsive === 'autoHeight' &&
    css `
      & img {
        width: 100%;
        height: auto;
      }
    `}
  ${(props) => props.imgResponsive === 'autoWidth' &&
    css `
      & img {
        width: auto;
        height: 100%;
      }
    `}
`;
const CardContent = (_a) => {
    var { dark = false, children, align = 'left', imgResponsive = 'autoHeight' } = _a, props = __rest(_a, ["dark", "children", "align", "imgResponsive"]);
    return (_jsx(CardContentStyle, Object.assign({ align: align, imgResponsive: imgResponsive, dark: dark }, props, { children: children })));
};
export default CardContent;
